import type { FaireProductEntity } from "../../entity_types/product";

export const p_8tcs78yja8: FaireProductEntity = {
  token: "p_8tcs78yja8",
  type: "product",
  name: "Mini Soy Candles - 2 oz - Mother's Day Gift",
  brandToken: "b_f2hc54t1",
  brandName: "Slow North",
  imageUrl:
    "https://cdn.faire.com/fastly/e0adc779168a100b8f02ee8e3bb33fc396233850a2cfd375c449f2a8aadbd970.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b47755742780f1d3c99b80419b32cf8170c4d92be4542a676e66d0510fb76c03.jpeg",
    "https://cdn.faire.com/fastly/e76aaee233311c8c05eeb14b5fd3c69f61c634da1ec184ade0a5853cc656d561.jpeg",
    "https://cdn.faire.com/fastly/eeba28c2480df25c1454fdda82803fd229e252905a8a80cb35419d43b071115c.jpeg",
    "https://cdn.faire.com/fastly/695c45787f94f1f96c63e6653d058d77c3f265b1b7c484af39422a52c87cea0f.png",
    "https://cdn.faire.com/fastly/c41b9f8d51134237cbae74ca7cf343abdbb1cb09aa8269e3d834a3b4ea2b98bc.png",
    "https://cdn.faire.com/fastly/a0767d6d6042e225a8f552b1f5eec01ed7f545f2f8ac0a4f20b945eede74e98e.png",
    "https://cdn.faire.com/fastly/850be16824817c1e82c99404dcca5326ad2b0436116a37f1e63b6af8d9ddabde.png",
    "https://cdn.faire.com/fastly/bd9d972a14ff89d95050da094b0dda6b1db8e75b673af42d9753cf8cc94fb191.png",
    "https://cdn.faire.com/fastly/ab90722c1ba59240bed5540302af22d494485bba59019f8d2d1ebe4b3bdaf80a.png",
    "https://cdn.faire.com/fastly/ceb9a351e5d9e1fac697374b88c443d0af2ad9a8ab77674afd6254f13d7689a6.png",
    "https://cdn.faire.com/fastly/2efa2584e72b2c1e4f95b0f4c3b4e1ca2a35145f54a33f61879bd7ef1806e547.png",
    "https://cdn.faire.com/fastly/f8e83a3a956fa510606c67f24e1e2c8267ab06ad02524e4b09ec9e250363d8ae.png",
    "https://cdn.faire.com/fastly/ce6ef37a2561d1a4dd0f9144e437ca4a0b40e496648204ddf5147ce97873a021.png",
    "https://cdn.faire.com/fastly/0a366dfb5d4ba3857d14a4e3eb65605084e216f754a42971479c30fb8804618d.png",
    "https://cdn.faire.com/fastly/37e0130c3e111c2c9142b3a35b5968427e3e1b4de10125d0090689ee6df6e6c5.png",
    "https://cdn.faire.com/fastly/ed916378790227aa8795244c0ff5fa42a777dcf23750a67cfee134272c267237.png",
    "https://cdn.faire.com/fastly/7b06abd853ae7473b7c1743dde43fea0c9c8a85b47e3fbe44eb865c770a4f18c.jpeg",
    "https://cdn.faire.com/fastly/2625b0964833d0217343e49171914b4ccb9e7d48f3070a071d643775deeb3a4b.png",
    "https://cdn.faire.com/fastly/518841a95eab43f7cae313e5b41bf2e593b6309f74b86bdda18003b9ab71fcb2.png",
    "https://cdn.faire.com/fastly/715bb31bf39d21dda7e48ec46d5c2495a7f360f73d98d9ff6b71134a38e7be28.png",
  ],
  priceDollars: 5.25,
  description:
    "Miniature versions of our classic 6 oz Travel Candles, these 2 oz Mini Candles are the perfect trial size or add-on purchase to sell near your checkout stand. \n\nSlow North creates the finest plant-based, soy-wax candles for any space. From our 100% essential oil fragrances to our cotton and paper wicks, our products redefine all-natural luxury. Our candles are vegan and free from artificial dyes and ingredients. You will enjoy a lighter, naturally enticing aroma when burning a candle scented only with pure essential oils.\n\nFrom ingredients to vessels, Slow North candles are designed with sustainability in mind. We’re proud to use only soy wax, a long-burning, biodegradable and renewable resource. These candles are poured into reusable, brushed gold travel tins.\n\n\nVolume: 2 oz\nDiameter: 1.75”\nHeight: 1.5”\n\n\n",
  tags: [],
  msrpDollars: 10.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:47.306Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
